module.exports = __webpack_public_path__ + "img/icon2.a4da3719.svg";